import { useQueryParams } from './use-query-params'
import {
  CONTINUE_URL_QUERY_PARAM,
  REAUTHENTICATE_QUERY_PARAM,
  SECURITY_QUERY_PARAM,
  DELETE_ACCOUNT_QUERY_PARAM,
} from 'config/constants'

const isSecurity = (continueUrl: string) => {
  try {
    const urlObject = new URL(continueUrl)
    return !!(
      urlObject && urlObject.searchParams.get(SECURITY_QUERY_PARAM) === 'true'
    )
  } catch {
    return false
  }
}

const isDeleteAccount = (continueUrl: string) => {
  try {
    const urlObject = new URL(continueUrl)
    return !!(
      urlObject &&
      urlObject.searchParams.get(DELETE_ACCOUNT_QUERY_PARAM) === 'true'
    )
  } catch {
    return false
  }
}

const isReauthenticate = (continueUrl: string) => {
  try {
    const urlObject = new URL(continueUrl)
    return !!(
      urlObject &&
      urlObject.searchParams.get(REAUTHENTICATE_QUERY_PARAM) === 'true'
    )
  } catch {
    return false
  }
}

export const useAuthParams = () => {
  const getParam = useQueryParams()

  const continueUrl = getParam(CONTINUE_URL_QUERY_PARAM)
  const reauthenticateParam = getParam(REAUTHENTICATE_QUERY_PARAM)
  const securityParam = getParam(SECURITY_QUERY_PARAM)
  const deleteAccountParam = getParam(DELETE_ACCOUNT_QUERY_PARAM)

  const security = isSecurity(continueUrl) || securityParam === 'true'
  const deleteAccount =
    isDeleteAccount(continueUrl) || deleteAccountParam === 'true'
  const reauthenticate =
    isReauthenticate(continueUrl) || reauthenticateParam === 'true'

  return {
    security,
    deleteAccount,
    reauthenticate,
    continueUrl,
  }
}
